import { Component, OnDestroy, OnInit } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { Partner } from '../_models/partner';
import { MessService } from '../_services/mess-service.service';
import { PartnersService } from '../_services/partners.service';

@Component({
  selector: 'app-partners',
  templateUrl: './partners.component.html',
})
export class PartnersComponent implements OnInit, OnDestroy {
  loading: boolean = true;

  partners: Partner[];

  subscriptions: Subscription[] = [];

  constructor(
    private partnersService: PartnersService,
    private confirmationService: ConfirmationService,
    private messService: MessService
  ) {}

  // * Lifecycle === //
  ngOnInit(): void {
    this.subscriptions.push(
      this.partnersService
        .getAllPartners()
        .subscribe((responseData: Partner[]) => {
          this.partners = responseData;
          this.loading = false;
        })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  // *Delete/Edit === //
  onDeletePartner(event, partnerId: number) {
    this.confirmationService.confirm({
      target: event.target,
      message: 'Da li ste sigurni da želite da obrišete partnera?',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.partnersService.deletePartner(partnerId).subscribe(
          () => {
            this.messService.add({
              severity: 'success',
              title: 'Uspešno brisanje',
              detail: 'Obrisali ste partnera.',
            });
            this.updatePartnerList();
          },
          (error) => {
            this.messService.add({
              severity: 'error',
              title: 'Greška',
              detail: 'Došlo je do greške, pokušajte ponovo!',
            });
          }
        );
      },
    });
  }

  onEditPartner(partner: Partner) {
    this.partnersService.updatePartnerData.next(partner);
  }

  // * Helpers === //
  private updatePartnerList() {
    this.loading = true;
    this.subscriptions.push(
      this.partnersService
        .getAllPartners()
        .subscribe((responseData: Partner[]) => {
          this.partners = responseData;
          this.loading = false;
        })
    );
  }
}
